import React, { useState } from 'react';
import { LoadScript, GoogleMap, Marker, InfoWindow } from '@react-google-maps/api';
import { GOOGLE_MAP_API_KEY } from 'assets/constants/Constants';
import config from '../config.json';

export const AllMeterMapViewComponent = ({ markers }) => {
  const [selectedMarker, setSelectedMarker] = useState(null);

  const getMarkerIcon = (meterType) => {
    switch (meterType) {
      case 'Flow':
        return {
          url: config.FLOW_MAP_IMAGE,
        };
      case 'Pressure':
        return {
          url: config.PRESSURE_MAP_IMAGE,
        };
      case 'Level':
        return {
          url: config.LEVEL_MAP_IMAGE,
        };
      case 'Temperature':
        return {
          url: config.TEMPERATURE_MAP_IMAGE,
        };
        case 'Over Head Tank':
        return {
          url: config.OHT_MAP_IMAGE,
        };
      default:
        return {
          url: config.FLOW_MAP_IMAGE,
        };
    }
  };

  const isValidLatLng = (lat, lng) => {
    return !isNaN(lat) && lat !== '' && !isNaN(lng) && lng !== '';
  };

  const getValidMapCenter = (markers) => {
    for (let i = 0; i < markers.length; i++) {
      const lat = parseFloat(markers[i].gps_latitude);
      const lng = parseFloat(markers[i].gps_longitude);
      if (isValidLatLng(lat, lng)) {
        return { lat, lng };
      }
    }
    return { lat: 18.5167, lng: 73.8563 };
  };

  const mapCenter = getValidMapCenter(markers);

  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAP_API_KEY}>
      <GoogleMap
        mapContainerStyle={{
          height: '500px',
          width: '100%',
        }}
        center={mapCenter}
        zoom={11}
        onClick={() => setSelectedMarker(null)} 
      >
        {markers.map((marker, index) => {
          const lat = parseFloat(marker.gps_latitude);
          const lng = parseFloat(marker.gps_longitude);

          if (isValidLatLng(lat, lng)) {
            return (
              <Marker
                key={index}
                position={{ lat, lng }}
                icon={getMarkerIcon(marker.meter_type)}
                onClick={() => setSelectedMarker(marker)}
              >
                {selectedMarker && selectedMarker.serial_number === marker.serial_number && (
                  <InfoWindow position={{ lat, lng }} onCloseClick={() => setSelectedMarker(null)}>
                    <div>
                      <h5 style={{ marginBottom: '20px' }}>Meter Details</h5>
                      <p><strong>Serial Number:</strong> {marker.serial_number}</p>
                      <p><strong>Status:</strong> {marker.status}</p>
                      <p><strong>Meter Type:</strong> {marker.meter_type}</p>
                    </div>
                  </InfoWindow>
                )}
              </Marker>
            );
          } else {
            return null;
          }
        })}
      </GoogleMap>
    </LoadScript>
  );
};
